import React from "react"
import TabbedListingPage from "../Material/TabbedListingPage"
import ReservedCars from "../CA/ReservedCars/ReservedCarsContainer"
import InactiveReservationsListContainer from "./InactiveReservationsListContainer"
import AllReservationsListContainer from "./AllReservationsListContainer"
import ReportsPanel from "../Reports/ReportsPanel"
import { ROUTES } from "../Layout/routes"

// Each panel container self-supplies location/navigate via its own withApolloClient
// wrap, so the only thing it actually reads off props is currentUser. Reports needs
// neither -- ReportsPanel owns its own date range, filters and view state.
const reservationsTabs = [
    { id: "open", name: "Reserved Cars", iconClassName: "fa fa-calendar-check-o", permissionRequired: null, render: ({ currentUser }) => <ReservedCars currentUser={currentUser} /> },
    { id: "awaiting", name: "Awaiting Reservations", iconClassName: "fa fa-calendar-minus-o", permissionRequired: null, render: ({ currentUser }) => <InactiveReservationsListContainer currentUser={currentUser} /> },
    { id: "all", name: "All Reservations", iconClassName: "fa fa-calendar-o", permissionRequired: null, render: ({ currentUser }) => <AllReservationsListContainer currentUser={currentUser} /> },
    { id: "reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true, permissionRequired: null, render: () => <ReportsPanel reportId="reservations" /> },
]

const ReservationsPage = (props) => (
    <TabbedListingPage
        className="reservationsPage"
        route={ROUTES.reservations}
        tabs={reservationsTabs.map(tab => ({ ...tab, render: () => tab.render({ currentUser: props.currentUser }) }))}
    />
)

export { reservationsTabs }

export default ReservationsPage
